export default "__VITE_ASSET__ktYO4SCZ__"